/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateSurveyDto
 */
export interface CreateUpdateSurveyDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyDto
     */
    nameEn: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyDto
     */
    frequency: CreateUpdateSurveyDtoFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyDto
     */
    contractorType: CreateUpdateSurveyDtoContractorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateSurveyDto
     */
    validityPeriodDays: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSurveyDto
     */
    remind: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSurveyDto
     */
    active: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSurveyDto
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSurveyDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyDto
     */
    emailSubject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyDto
     */
    emailSubjectEn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyDto
     */
    emailBody?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyDto
     */
    emailBodyEn?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateSurveyDto
     */
    companyIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateSurveyDto
     */
    employeeIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyDto
     */
    contactTypeId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSurveyDto
     */
    sendToGeneral?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyDto
     */
    clientGroupId?: string | null;
}


/**
 * @export
 */
export const CreateUpdateSurveyDtoFrequencyEnum = {
    OnceAYear: 'OnceAYear',
    SemiAnnually: 'SemiAnnually',
    Quarterly: 'Quarterly',
    Monthly: 'Monthly'
} as const;
export type CreateUpdateSurveyDtoFrequencyEnum = typeof CreateUpdateSurveyDtoFrequencyEnum[keyof typeof CreateUpdateSurveyDtoFrequencyEnum];

/**
 * @export
 */
export const CreateUpdateSurveyDtoContractorTypeEnum = {
    All: 'All',
    Purchaser: 'Purchaser',
    Supplier: 'Supplier',
    Group: 'Group'
} as const;
export type CreateUpdateSurveyDtoContractorTypeEnum = typeof CreateUpdateSurveyDtoContractorTypeEnum[keyof typeof CreateUpdateSurveyDtoContractorTypeEnum];


/**
 * Check if a given object implements the CreateUpdateSurveyDto interface.
 */
export function instanceOfCreateUpdateSurveyDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "nameEn" in value;
    isInstance = isInstance && "frequency" in value;
    isInstance = isInstance && "contractorType" in value;
    isInstance = isInstance && "validityPeriodDays" in value;
    isInstance = isInstance && "remind" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function CreateUpdateSurveyDtoFromJSON(json: any): CreateUpdateSurveyDto {
    return CreateUpdateSurveyDtoFromJSONTyped(json, false);
}

export function CreateUpdateSurveyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateSurveyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'nameEn': json['nameEn'],
        'frequency': json['frequency'],
        'contractorType': json['contractorType'],
        'validityPeriodDays': json['validityPeriodDays'],
        'remind': json['remind'],
        'active': json['active'],
        'startDate': !exists(json, 'startDate') ? undefined : (json['startDate'] === null ? null : new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (json['endDate'] === null ? null : new Date(json['endDate'])),
        'emailSubject': !exists(json, 'emailSubject') ? undefined : json['emailSubject'],
        'emailSubjectEn': !exists(json, 'emailSubjectEn') ? undefined : json['emailSubjectEn'],
        'emailBody': !exists(json, 'emailBody') ? undefined : json['emailBody'],
        'emailBodyEn': !exists(json, 'emailBodyEn') ? undefined : json['emailBodyEn'],
        'companyIds': !exists(json, 'companyIds') ? undefined : json['companyIds'],
        'employeeIds': !exists(json, 'employeeIds') ? undefined : json['employeeIds'],
        'contactTypeId': !exists(json, 'contactTypeId') ? undefined : json['contactTypeId'],
        'sendToGeneral': !exists(json, 'sendToGeneral') ? undefined : json['sendToGeneral'],
        'clientGroupId': !exists(json, 'clientGroupId') ? undefined : json['clientGroupId'],
    };
}

export function CreateUpdateSurveyDtoToJSON(value?: CreateUpdateSurveyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'nameEn': value.nameEn,
        'frequency': value.frequency,
        'contractorType': value.contractorType,
        'validityPeriodDays': value.validityPeriodDays,
        'remind': value.remind,
        'active': value.active,
        'startDate': value.startDate === undefined ? undefined : (value.startDate === null ? null : value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate === null ? null : value.endDate.toISOString()),
        'emailSubject': value.emailSubject,
        'emailSubjectEn': value.emailSubjectEn,
        'emailBody': value.emailBody,
        'emailBodyEn': value.emailBodyEn,
        'companyIds': value.companyIds,
        'employeeIds': value.employeeIds,
        'contactTypeId': value.contactTypeId,
        'sendToGeneral': value.sendToGeneral,
        'clientGroupId': value.clientGroupId,
    };
}

